import { format } from "date-fns/format";
import { nb } from "date-fns/locale/nb";
import { VehicleBooking } from "features/CenterContent/VehicleDetails/ReserveAlternativeTransportDetails/VehicleBooking";
import { VehiclePhoneNumber } from "features/CenterContent/VehicleDetails/shared/VehiclePhoneNumber";
import { VehicleSummary } from "features/CenterContent/VehicleDetails/shared/VehicleSummary";
import { vehicleTypeToIcon } from "features/CenterContent/VehicleDetails/shared/utils";
import { FC } from "react";
import { useLocation } from "react-router-dom";
import { HStack } from "shared/components/Spor";
import { ReserveAlternativeTransport } from "shared/types/alternativeTransport";
import styled from "styled-components";

type Props = {
  reserveAlternativeTransport: ReserveAlternativeTransport;
};

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: 1 / span 1;
`;

export const BackupVehicleInfo: FC<Props> = ({
  reserveAlternativeTransport,
}) => {
  const location = useLocation();
  const {
    id,
    baseStopName,
    workShiftId,
    shiftStartTime,
    operatorName,
    shiftEndTime,
    type,
    driverPhoneNumber,
    logs,
  } = reserveAlternativeTransport;
  const [_Icon, _iconTitle] = vehicleTypeToIcon.get(type)!;

  const { vehicleTitle } = location.state || { vehicleTitle: "Beredskap" };

  const dateAndTime = [shiftStartTime, shiftEndTime]
    .filter((date) => date !== null)
    .map((date) => format(date, "HH:mm (dd.MM.yy)", { locale: nb }))
    .join("–");

  return (
    <InfoWrapper>
      <VehicleSummary
        vehicleInfo={operatorName}
        title={vehicleTitle}
        type={type}
        subTitle={workShiftId}
        route={baseStopName}
        interval={dateAndTime}
        vehicleStatus={null}
        logs={logs ?? []}
        driverPhoneNumber={driverPhoneNumber}
      />

      <HStack role="group" mt="12px">
        <VehiclePhoneNumber
          phoneNumberUpdate={driverPhoneNumber}
          id={id}
          operatorUpdate={{
            operatorId: reserveAlternativeTransport.operatorId,
            operatorName,
          }}
        />
        <VehicleBooking vehicle={reserveAlternativeTransport} />
      </HStack>
    </InfoWrapper>
  );
};
